import { MenuContentCmp as MenuContent } from '../../components/MenuCmp';
import UIControls from '../../components/UIControlsCmp';
import Urls from '../../constants/urls';
import { calendarId } from './data';
import overview from "./imgs/FloorPlanMap.jpg";
import { ImageMap } from '@qiuz/react-image-map';
import { useHistory } from "react-router-dom";
import spot from "../../icons/spot.png"



const VGMenuV2 = () => {
  const history = useHistory()
  let width = window.innerWidth;
  const mapArea = [
    {
      url: Urls.northWind.m22.path,
      width: '5%',
      height: '5%',
      left: '28%',
      top: '27%',
      render: () => (
        <>
        <span className='overview-map-button' >
          
          <img src={spot} />
        </span>
        {width > 900 ?  <div className='tooltiptext'>Click to enter the Main Gallery!</div>
          :<div className='tooltiptext'>Gallery</div> }
        </>
        
      ),
    },
    {
      url: Urls.northWind.m21.path,
      width: '5%',
      height: '5%',
      left: '46%',
      top: '27%',
      render: () => (
        <>
        <span className='overview-map-button'>
          
          <img src={spot} />
        </span>
          {width > 900 ?  <div className='tooltiptext'>Click to enter the Gallery!</div>
          :<div className='tooltiptext'>Entrance</div> }
        </>
      ),
    },
    {
      url: Urls.northWind.m02.path,
      width: '5%',
      height: '5%',
      left: '66%',
      top: '27%',
      render: () => (
        <>
        <span className='overview-map-button'>
          <img src={spot}/>
        </span>
        {width > 900 ?  <div className='tooltiptext'>Click to enter the Exhibit!</div>
          :<div className='tooltiptext'>Exhibit</div> }
        </>
      ),
    },
    {
      url: Urls.northWind.c2.path,
      width: '5%',
      height: '5%',
      left: '46%',
      top: '62.7%',
      
      render: () => (
        <>
        <span className='overview-map-button' >
          
          <img src={spot}/>
        </span>
        {width > 900 ?  <div className='tooltiptext'>Click to enter the Corridor!</div>
          :<div className='tooltiptext'>Corridor</div> }
        </>
      ),
    },
    {
      url: Urls.northWind.md01.path,
      width: '5%',
      height: '5%',
      left: '54%',
      top: '73.7%',
      render: () => (
         <>
        <span className='overview-map-button' >
          
          <img src={spot} />
        </span>
        {width > 900 ?  <div className='tooltiptext'>Click to enter the Salon!</div>
          :<div className='tooltiptext'>Salon</div> }
        </>
      ),
    },
  ];

  
  
  const onMapClick = (area) => {
    console.log(area);
    history.push(area.url)
  }
  return (
    <>
      <MenuContent>
        <h1>Where do you want to go?</h1>
      <ImageMap
        className="usage-map"
        src={overview}
        map={mapArea}
        onMapClick={onMapClick}
      />
      </MenuContent> 
      <UIControls
        cart
        calendarId={calendarId}
        homeUrl={Urls.northWind.c2.path}
      />
    </>
  );
}

export default VGMenuV2;
